import { z } from 'zod'

export const datasetSchema = z.object({
  slug: z.string().min(1),
  iziQrJs: z.string().min(1),
  iziQrCss: z.string().min(1),
  showExitCross: z.boolean(),
  showLogo: z.boolean(),
  showTitle: z.boolean(),
  showSummary: z.boolean(),
  numberedQuestions: z.boolean(),
  restartQr: z.boolean(),
  parcoursType: z.string(),
  sendToLeadData: z.record(z.string(), z.any()),
  showFirstReturn: z.boolean(),
  hideProgressBarInFirstQuestion: z.boolean(),

  iziZipcodeJs: z.string().optional(),
  iziZipcodeCss: z.string().optional(),
  iziEndformJs: z.string().optional(),
  iziEndformCss: z.string().optional(),
  iziEndRedirect: z.string().optional(),
  disableCallbackDate: z.boolean().optional(),
  logoPartner: z.string().optional(),
  partner: z.string().optional(),
  zipCode: z.string().length(5).optional(),
  maxStep: z.number().optional(),
  fallbackUrl: z.string().optional(),
  thumbnail: z.string().optional(),
  endUploadTab: z.boolean().optional(),
})

export type DatasetSchema = z.infer<typeof datasetSchema>

export const mapRootElDataset = (dataset: DOMStringMap): DatasetSchema => ({
  ...dataset,
  slug: dataset?.slug ?? '',
  iziQrJs: dataset?.iziQrJs ?? '',
  iziQrCss: dataset?.iziQrCss ?? '',
  ...(dataset?.maxStep ? { maxStep: +dataset.maxStep } : {}),
  fallbackUrl: dataset?.fallbackUrl,
  showFirstReturn: dataset?.showFirstReturn === 'false' ? false : true,
  hideProgressBarInFirstQuestion: dataset?.hideProgressBarInFirstQuestion === 'true' ? true : false,
  parcoursType: dataset?.parcoursType || 'parcours_qr',
  restartQr: dataset?.restartQr === 'true' ? true : false,
  sendToLeadData: dataset?.sendToLeadData ? JSON.parse(dataset?.sendToLeadData) : {},
  disableCallbackDate: dataset?.disableCallbackDate === 'true' ? true : false,
  numberedQuestions: dataset?.numberedQuestions === 'true' ? true : false,
  showExitCross: dataset?.showExitCross === 'true' ? true : false,
  showLogo: dataset?.showLogo === 'true' ? true : false,
  showTitle: dataset?.showTitle === 'true' ? true : false,
  showSummary: dataset?.showSummary === 'true' ? true : false,
  endUploadTab: dataset?.endUploadTab === 'true' ? true : false,
})
